var $class="se2--header-se--country-selector-modal",$name="HeaderSE/countrySelectorModal",$path="app/components/HeaderSE/deferrals/countrySelectorModal/config.js",$this={$class,$name,$path,};// eslint-disable-next-line import/prefer-default-export
export const countrySelectorSEClassName = $class;
export const countrySelectorSESectionSelector = `.${$class} .section`;
